<template>
  <v-btn flat type="submit" color="primary" @click="searchByQuery">
    <v-icon>search</v-icon>
  </v-btn>
</template>

<script>
import TransactionService from '../services/TransactionsService'
import SubscriptionsService from '../services/SubscriptionsService'
import WebhookLogsService from '../services/WebhookLogsService'
import Raygun from '../services/Raygun'

export default {
  name: 'Search',
  methods: {
    async searchByQuery () {
      try {
        let searchValue = this.$store.state.searchValue
        let dateRangeStart = this.$store.state.dateRange.startDate
        let dateRangeEnd = this.$store.state.dateRange.endDate
        let searchQuery = {
          searchValue,
          dates: {
            startDate: dateRangeStart,
            endDate: dateRangeEnd
          }
        }

        let collectionType = this.$route.name.toLowerCase()
        if (collectionType === 'transactions') {
          let response = await TransactionService.search({searchQuery})
          this.$store.commit('setTransactions', response.data)
        } else if (collectionType === 'subscriptions') {
          let response = await SubscriptionsService.search({searchQuery})
          this.$store.commit('setSubscriptions', response.data)
        } else if (collectionType === 'webhooklogs') {
          let response = await WebhookLogsService.search({searchQuery})
          this.$store.commit('setWebhooklogs', response.data)
        } else {
          console.error('unknown collection')
        }
      } catch (error) {
        this.error = error.message
        Raygun.send(error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Search.vue